export function useBodyScrollLock(locked: boolean | Ref<boolean> = false, allowScrollTargetSelector?: string) {
  const isLocked = typeof locked === 'boolean' ? ref(locked) : locked
  let scrollY = 0
  let prevOverflow = ''
  let prevPosition = ''
  let prevTop = ''
  let prevWidth = ''
  let handler: ((e: TouchEvent) => void) | null = null

  const setLock = () => {
    scrollY = window.scrollY
    prevOverflow = document.body.style.overflow
    prevPosition = document.body.style.position
    prevTop = document.body.style.top
    prevWidth = document.body.style.width

    document.body.style.overflow = 'hidden'
    document.body.style.position = 'fixed'
    document.body.style.top = `-${scrollY}px`
    document.body.style.width = '100%'

    // Для iOS: запрещаем скролл через touchmove, кроме allowScrollTarget
    handler = (e: TouchEvent) => {
      if (allowScrollTargetSelector && (e.target as Element)?.closest(allowScrollTargetSelector)) {
        return // разрешить прокрутку внутри модалки
      }
      e.preventDefault()
    }
    document.addEventListener('touchmove', handler, { passive: false })
  }

  const unsetLock = () => {
    document.body.style.overflow = prevOverflow
    document.body.style.position = prevPosition
    document.body.style.top = prevTop
    document.body.style.width = prevWidth

    window.scrollTo(0, scrollY)
    if (handler) {
      document.removeEventListener('touchmove', handler)
      handler = null
    }
  }

  watch(() => isLocked.value, () => {
    if (isLocked.value) {
      setLock()
    } else {
      unsetLock()
    }
  })

  return {
    isLocked,
  }
}
